export const pattern2Data = [
  {
    id: 1,
    koreanChunks: ["그 프로젝트는", "남아있는 상태다", "완료되지 않은채로"],
    englishChunks: ["The project", "remains", "unfinished"],
    fullEnglish: "The project remains unfinished.",
    explanation:
      "주어(S) + be동사(remains) + 보어(C) 구조의 2형식 문장입니다. 주어인 '프로젝트'와 보어인 '미완료 상태'가 동일시됩니다.",
  },
  {
    id: 2,
    koreanChunks: [
      "어려움에도 불구하고,",
      "그녀는",
      "유지하는 상태다",
      "침착한",
    ],
    englishChunks: ["Despite the challenges,", "she", "stayed", "calm"],
    fullEnglish: "Despite the challenges, she stayed calm.",
    explanation:
      "주어(S) + stay + 보어(C) 구조의 2형식 문장입니다. 주어인 '그녀'와 보어인 '침착한 상태'가 동일시됩니다.",
  },
  {
    id: 3,
    koreanChunks: [
      "그 문제는",
      "유지되있다",
      "해결되지 않은 상태로",
      "몇 주 동안",
    ],
    englishChunks: ["The issue", "kept", "unresolved", "for weeks"],
    fullEnglish: "The issue kept unresolved for weeks.",
    explanation:
      "주어(S) + keep + 보어(C) 구조의 2형식 문장입니다. 주어인 '문제'와 보어인 '해결되지 않은 상태'가 동일시됩니다.",
  },
  {
    id: 4,
    koreanChunks: ["그 일자리 제안은", "여전히", "유효한 상태이다"],
    englishChunks: ["The job offer is", "still", "available"],
    fullEnglish: "The job offer is still available.",
    explanation:
      "주어(S) + be동사(is) + 보어(C) 구조의 2형식 문장입니다. 주어인 '일자리 제안'과 보어인 '유효한 상태'가 동일시됩니다.",
  },
  {
    id: 5,
    koreanChunks: ["그 제안은", "보인다", "전망이 좋은 상태로"],
    englishChunks: ["The proposal", "looks", "promising"],
    fullEnglish: "The proposal looks promising.",
    explanation:
      "주어(S) + look + 보어(C) 구조의 2형식 문장입니다. 주어인 '제안'과 보어인 '전망이 좋은 상태'가 동일시됩니다.",
  },
  {
    id: 6,
    koreanChunks: ["새로운 정책은", "들린다", "합리적인"],
    englishChunks: ["The new policy", "sounds", "reasonable"],
    fullEnglish: "The new policy sounds reasonable.",
    explanation:
      "주어(S) + sound + 보어(C) 구조의 2형식 문장입니다. 주어인 '정책'과 보어인 '합리적인 상태'가 동일시됩니다.",
  },
  {
    id: 7,
    koreanChunks: ["긴 하루 이후,", "그는", "느꼈다", "지친"],
    englishChunks: ["After a long day,", "he", "felt", "exhausted"],
    fullEnglish: "After a long day, he felt exhausted.",
    explanation:
      "주어(S) + feel + 보어(C) 구조의 2형식 문장입니다. 주어인 '그'와 보어인 '지친 상태'가 동일시됩니다.",
  },
  {
    id: 8,
    koreanChunks: ["갓 구운 빵은", "냄새가 난다", "아주 좋은"],
    englishChunks: ["The freshly baked bread", "smells", "amazing"],
    fullEnglish: "The freshly baked bread smells amazing.",
    explanation:
      "주어(S) + smell + 보어(C) 구조의 2형식 문장입니다. 주어인 '빵'과 보어인 '좋은 냄새가 나는 상태'가 동일시됩니다.",
  },
  {
    id: 9,
    koreanChunks: ["그 수프는", "맛이 난다", "맛있는"],
    englishChunks: ["The soup", "tastes", "delicious"],
    fullEnglish: "The soup tastes delicious.",
    explanation:
      "주어(S) + taste + 보어(C) 구조의 2형식 문장입니다. 주어인 '수프'와 보어인 '맛있는 상태'가 동일시됩니다.",
  },
  {
    id: 10,
    koreanChunks: ["그는", "되었다", "매니저가", "5년 후"],
    englishChunks: ["He", "became", "a manager", "after five years"],
    fullEnglish: "He became a manager after five years.",
    explanation:
      "주어(S) + become + 보어(C) 구조의 2형식 문장입니다. 주어인 '그'와 보어인 '매니저'가 동일시됩니다.",
  },
  {
    id: 11,
    koreanChunks: ["그 상황은", "되어가고 있는 상태다", "점점 더 악화"],
    englishChunks: ["The situation", "is getting", "worse"],
    fullEnglish: "The situation is getting worse.",
    explanation:
      "주어(S) + get + 보어(C) 구조의 2형식 문장입니다. 주어인 '상황'과 보어인 '악화된 상태'가 동일시됩니다.",
  },
  {
    id: 12,
    koreanChunks: ["그 사업은", "자랐다", "성공적인 상태로", "몇 년에 걸쳐"],
    englishChunks: ["The business", "grew", "successful", "over the years"],
    fullEnglish: "The business grew successful over the years.",
    explanation:
      "주어(S) + grow + 보어(C) 구조의 2형식 문장입니다. 주어인 '사업'과 보어인 '성공적인 상태'가 동일시됩니다.",
  },
  {
    id: 13,
    koreanChunks: ["나뭇잎이", "변했다", "노랗게", "가을에"],
    englishChunks: ["The leaves", "turned", "yellow", "in autumn"],
    fullEnglish: "The leaves turned yellow in autumn.",
    explanation:
      "주어(S) + turn + 보어(C) 구조의 2형식 문장입니다. 주어인 '나뭇잎'과 보어인 '노란 상태'가 동일시됩니다.",
  },
  {
    id: 14,
    koreanChunks: ["그의 설명은", "판명되었다", "유용한 것으로"],
    englishChunks: ["His explanation", "proved", "helpful"],
    fullEnglish: "His explanation proved helpful.",
    explanation:
      "주어(S) + prove + 보어(C) 구조의 2형식 문장입니다. 주어인 '설명'과 보어인 '유용한 상태'가 동일시됩니다.",
  },
  {
    id: 15,
    koreanChunks: ["그 계획은", "보인다", "실행 가능한"],
    englishChunks: ["The plan", "seems", "feasible"],
    fullEnglish: "The plan seems feasible.",
    explanation:
      "주어(S) + seem + 보어(C) 구조의 2형식 문장입니다. 주어인 '계획'과 보어인 '실행 가능한 상태'가 동일시됩니다.",
  },
  {
    id: 16,
    koreanChunks: ["그 사무실은", "닫은 상태다", "주말에는"],
    englishChunks: ["The office is", "closed", "on weekends"],
    fullEnglish: "The office is closed on weekends.",
    explanation:
      "주어(S) + be동사(is) + 보어(C) 구조의 2형식 문장입니다. 주어인 '사무실'과 보어인 '닫힌 상태'가 동일시됩니다.",
  },

  {
    id: 17,
    koreanChunks: ["문이", "잠긴 상태였다", "우리가 도착했을 때"],
    englishChunks: ["The door was", "locked", "when we arrived"],
    fullEnglish: "The door was locked when we arrived.",
    explanation:
      "주어(S) + be동사(was) + 보어(C) 구조의 2형식 문장입니다. 주어인 '문'과 보어인 '잠긴 상태'가 동일시됩니다.",
  },
  {
    id: 18,
    koreanChunks: ["창문들이", "열려있는 상태이다"],
    englishChunks: ["The windows are", "open"],
    fullEnglish: "The windows are open.",
    explanation:
      "주어(S) + be동사(are) + 보어(C) 구조의 2형식 문장입니다. 주어인 '창문들'과 보어인 '열린 상태'가 동일시됩니다.",
  },
  {
    id: 19,
    koreanChunks: ["CEO 선발 과정은", "남아있는 상태다", "매우 치열한"],
    englishChunks: [
      "The CEO selection process",
      "remains",
      "highly competitive",
    ],
    fullEnglish: "The CEO selection process remains highly competitive.",
    explanation:
      "주어(S) + remain + 보어(C) 구조의 2형식 문장입니다. 주어인 'CEO 선발 과정'과 보어인 '경쟁이 치열한 상태'가 동일시됩니다.",
  },
  {
    id: 20,
    koreanChunks: ["지원자의 자격은", "보인다", "적합한", "관리직에"],
    englishChunks: [
      "The applicant's qualifications",
      "appear",
      "suitable",
      "for the managerial role",
    ],
    fullEnglish:
      "The applicant's qualifications appear suitable for the managerial role.",
    explanation:
      "주어(S) + appear + 보어(C) 구조의 2형식 문장입니다. 주어인 '지원자의 자격'과 보어인 '적합한 상태'가 동일시됩니다.",
  },
  {
    id: 21,
    koreanChunks: ["근무 유연성은", "되었다", "필수적인", "직원 만족도를 위해"],
    englishChunks: [
      "Workplace flexibility",
      "has become",
      "essential",
      "for employee satisfaction",
    ],
    fullEnglish:
      "Workplace flexibility has become essential for employee satisfaction.",
    explanation:
      "주어(S) + become + 보어(C) 구조의 2형식 문장입니다. 주어인 '근무 유연성'과 보어인 '필수적인 요소'가 동일시됩니다.",
  },
  {
    id: 22,
    koreanChunks: [
      "주식 시장 전망이",
      "상태를 유지한다",
      "불확실한",
      "금리 변동으로 인해",
    ],
    englishChunks: [
      "The stock market outlook",
      "stays",
      "uncertain",
      "due to fluctuating interest rates",
    ],
    fullEnglish:
      "The stock market outlook stays uncertain due to fluctuating interest rates.",
    explanation:
      "주어(S) + stay + 보어(C) 구조의 2형식 문장입니다. 주어인 '주식 시장 전망'과 보어인 '불확실한 상태'가 동일시됩니다.",
  },
  {
    id: 23,
    koreanChunks: ["투자자 신뢰가", "보인다", "약해", "최근 경기 침체 이후"],
    englishChunks: [
      "Investor confidence",
      "seems",
      "fragile",
      "after the recent economic downturn",
    ],
    fullEnglish:
      "Investor confidence seems fragile after the recent economic downturn.",
    explanation:
      "주어(S) + seem + 보어(C) 구조의 2형식 문장입니다. 주어인 '투자자 신뢰'와 보어인 '약한 상태'가 동일시됩니다.",
  },
  {
    id: 24,
    koreanChunks: [
      "회사의 매출 성장은",
      "판명되었다",
      "꾸준한 것으로",
      "지난 1년간",
    ],
    englishChunks: [
      "The company's revenue growth",
      "proved",
      "steady",
      "over the past year",
    ],
    fullEnglish:
      "The company's revenue growth proved steady over the past year.",
    explanation:
      "주어(S) + prove + 보어(C) 구조의 2형식 문장입니다. 주어인 '회사의 매출 성장'과 보어인 '꾸준한 상태'가 동일시됩니다.",
  },
  {
    id: 25,
    koreanChunks: [
      "최신 의학 연구 결과는",
      "보인다",
      "유망해",
      "암 치료에 대해",
    ],
    englishChunks: [
      "The latest medical findings",
      "look",
      "promising",
      "for cancer treatment",
    ],
    fullEnglish:
      "The latest medical findings look promising for cancer treatment.",
    explanation:
      "주어(S) + look + 보어(C) 구조의 2형식 문장입니다. 주어인 '의학 연구 결과'와 보어인 '유망한 상태'가 동일시됩니다.",
  },
  {
    id: 26,
    koreanChunks: ["AI 기반 자동화 시스템이", "성장했다", "더 정교한"],
    englishChunks: [
      "The AI-driven automation system",
      "has grown",
      "more sophisticated",
    ],
    fullEnglish:
      "The AI-driven automation system has grown more sophisticated.",
    explanation:
      "주어(S) + grow + 보어(C) 구조의 2형식 문장입니다. 주어인 'AI 기반 자동화 시스템'과 보어인 '정교한 상태'가 동일시됩니다.",
  },
  {
    id: 27,
    koreanChunks: [
      "새로 개발된 약물은",
      "남아있는 상태다",
      "검토 하에",
      "승인 전에",
    ],
    englishChunks: [
      "The newly developed drug",
      "remained",
      "under review",
      "before approval",
    ],
    fullEnglish:
      "The newly developed drug remained under review before approval.",
    explanation:
      "주어(S) + remain + 보어(C) 구조의 2형식 문장입니다. 주어인 '약물'과 보어인 '검토 상태'가 동일시됩니다.",
  },
  {
    id: 28,
    koreanChunks: ["국제 영화상 후보들은", "들린다", "인상적인", "올해"],
    englishChunks: [
      "The international film nominees",
      "sound",
      "impressive",
      "this year",
    ],
    fullEnglish: "The international film nominees sound impressive this year.",
    explanation:
      "주어(S) + sound + 보어(C) 구조의 2형식 문장입니다. 주어인 '영화상 후보들'과 보어인 '인상적인 상태'가 동일시됩니다.",
  },
  {
    id: 29,
    koreanChunks: [
      "대중 반응",
      "새로운 방송 규정에 대한 ",
      "변했다",
      "부정적인 상태로",
    ],
    englishChunks: [
      "Public reaction",
      "to the new broadcasting regulations",
      "turned",
      "negative",
    ],
    fullEnglish:
      "Public reaction to the new broadcasting regulations turned negative.",
    explanation:
      "주어(S) + turn + 보어(C) 구조의 2형식 문장입니다. 주어인 '대중 반응'과 보어인 '부정적인 상태'가 동일시됩니다.",
  },
  {
    id: 30,
    koreanChunks: [
      "기자회견 분위기가",
      "됬다",
      "긴장감 있는",
      "예상치 못한 발표 이후",
    ],
    englishChunks: [
      "The press conference setting",
      "became",
      "tense",
      "after the unexpected announcement",
    ],
    fullEnglish:
      "The press conference setting became tense after the unexpected announcement.",
    explanation:
      "주어(S) + become + 보어(C) 구조의 2형식 문장입니다. 주어인 '기자회견 분위기'와 보어인 '긴장감 있는 상태'가 동일시됩니다.",
  },
];
